import React from 'react';
import { ReactThreeFiber } from 'react-three-fiber';
import { CustomObject } from '../../../types/data';
import { Text } from 'drei';
import { fontFamilyBold, textAlignCenter, textAlignLeft, textDirection } from '../../../config/ui';
import { useTexture } from '../../../hooks';
import Rating from '../../../components/xr/rating';
import Button from '../../../components/xr/button';
import bookBtn from '../../../assets/images/xr/icons/book-btn.png';

type BookingWindowProps = {
  data: CustomObject;

  position?: ReactThreeFiber.Vector3;
};

const BookingWindow = ({ data = {}, position }: BookingWindowProps) => {
  const { texture: bookBtnTxt } = useTexture(bookBtn);

  return (
    <mesh position={position}>
      <planeBufferGeometry args={[0.65, 0.1]} attach="geometry" />
      <meshBasicMaterial attach="material" color="#ffffff" />
      <Text
        position={[-0.3, 0.03, 0.0001]}
        color="#000"
        font={fontFamilyBold}
        fontSize={0.018}
        maxWidth={0.45}
        lineHeight={1.1}
        textAlign={textAlignLeft}
        direction={textDirection}
        anchorX="left"
        anchorY="top">
        {data.title}
      </Text>

      <group position={[0, -0.01, 0.0001]}>
        <group position={[-0.3, 0, 0]}>
          <Text
            position={[0, 0, 0]}
            color="#000"
            font={fontFamilyBold}
            fontSize={0.018}
            maxWidth={0.1}
            lineHeight={1.3}
            textAlign={textAlignLeft}
            anchorX="left"
            anchorY="top">
            {data.duration}
          </Text>

          <Rating value={data.rating} position={[0.1, -0.01, 0.0001]} />

          <Text
            position={[0.25, 0, 0]}
            color="#000"
            font={fontFamilyBold}
            fontSize={0.018}
            maxWidth={0.1}
            lineHeight={1.3}
            textAlign={textAlignLeft}
            anchorX="left"
            anchorY="top">
            ${data.price}
          </Text>
        </group>
        <group position={[0.22, 0.01, 0]}>
          <Button
            defaultState={{
              main: {
                width: 0.17,
                height: 0.05,
                material: {
                  map: bookBtnTxt,
                  transparent: true,
                },
              },
            }}
            onClick={() => {
              window.location.href = data.booking_url;
            }}>
            <Text
              position={[0, 0, 0.0001]}
              color="#fff"
              font={fontFamilyBold}
              fontSize={0.018}
              maxWidth={0.14}
              lineHeight={1.3}
              textAlign={textAlignCenter}
              anchorX="center"
              anchorY="middle">
              BOOK NOW
            </Text>
          </Button>
        </group>
      </group>
    </mesh>
  );
};

export default BookingWindow;
